var _path, _path2, _ellipse, _path3, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeakerWithShellLessEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 84,
    viewBox: "0 0 78 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5792 11.6781C75.1255 12.5061 74.0541 12.9312 73.0457 12.6851L71.7097 12.3494C67.974 13.8004 67.1126 15.1525 67 19.5V80.3538C67 82.4461 65.4173 84 63.0603 84H15.5059C13.1363 84 11 82.4461 11 80.3538L10.6415 8.21071C10.6415 6.68907 10.1121 5.33419 9.15416 4.05869C8.64999 3.09648 9.44406 2 10.6415 2H60.4288C65.8108 2 70.9534 3.958 74.6591 7.40407C76.0078 8.48936 76.3859 10.2348 75.5792 11.6781Z",
    fill: "#D9ECF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.712 57.5333C52.0092 45.5333 44.2446 39 39 39C33.7554 39 25.9908 45.5333 24.288 57.5333C22.6533 69.5333 28.0341 79 39 79C49.9659 79 55.3467 69.5333 53.712 57.5333Z",
    fill: "url(#paint0_radial_10225_30665)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.0872,
    cy: 69.1711,
    rx: 7.58721,
    ry: 7.4359,
    fill: "url(#paint1_radial_10225_30665)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9C15 8.44772 15.4477 8 16 8H25C25.5523 8 26 8.44772 26 9C26 9.55228 25.5523 10 25 10H17V22H25C25.5523 22 26 22.4477 26 23C26 23.5523 25.5523 24 25 24H17V36H25C25.5523 36 26 36.4477 26 37C26 37.5523 25.5523 38 25 38H17V50H25C25.5523 50 26 50.4477 26 51C26 51.5523 25.5523 52 25 52H17V64H25C25.5523 64 26 64.4477 26 65C26 65.5523 25.5523 66 25 66H17V78H25C25.5523 78 26 78.4477 26 79C26 79.5523 25.5523 80 25 80H16C15.4477 80 15 79.5523 15 79V65V51V37V23V9Z",
    fill: "#668BA6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7,
    width: 13,
    height: 73,
    rx: 3,
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10225_30665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39 59) rotate(90) scale(20 15)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3DD98"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10225_30665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0872 69.1711) rotate(90) scale(7.4359 7.58721)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#F69517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakerWithShellLessEgg);
export default __webpack_public_path__ + "static/media/beaker_with_shell_less_egg.07824928b5137522252c5d82c7c925f9.svg";
export { ForwardRef as ReactComponent };